import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { LayoutDashboard, Users, ArrowDownToLine, ArrowUpFromLine, Settings, LogOut, ShieldCheck, Repeat, FileBarChart, Coins, Megaphone, Crown } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const nav = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/users", label: "Users", icon: Users },
  { to: "/admin/deposits", label: "Deposits", icon: ArrowDownToLine },
  { to: "/admin/sweeps", label: "Sweeps", icon: Repeat },
  { to: "/admin/withdrawals", label: "Withdrawals", icon: ArrowUpFromLine },
  { to: "/admin/reports", label: "Reports", icon: FileBarChart },
  { to: "/admin/income-reports", label: "Incomes", icon: Coins },
  { to: "/admin/royalty", label: "Royalty", icon: Crown },
  { to: "/admin/news", label: "News", icon: Megaphone },
  { to: "/admin/settings", label: "Settings", icon: Settings },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#050507] flex">
      <aside className="hidden md:flex flex-col w-64 border-r border-amber-500/15 bg-[#08080C] fixed inset-y-0">
        <div className="h-20 flex items-center gap-2 px-6 border-b border-amber-500/15">
          <div className="w-9 h-9 rounded-xl bg-red-500/20 border border-red-500/30 grid place-items-center"><ShieldCheck className="w-5 h-5 text-red-400" /></div>
          <div className="font-display font-extrabold text-sm">Admin<span className="gold-text"> Panel</span></div>
        </div>
        <nav className="flex-1 p-4 space-y-1">
          {nav.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} data-testid={`admin-nav-${n.label.toLowerCase()}`}
              className={({ isActive }) => `flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium transition-all ${isActive ? "gold-btn" : "text-slate-400 hover:text-amber-300 hover:bg-amber-500/5"}`}>
              <n.icon className="w-5 h-5" /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-amber-500/15">
          <button data-testid="admin-logout-btn" onClick={() => { logout(); navigate("/"); }}
            className="flex items-center gap-3 px-4 py-3 rounded-xl text-sm text-slate-400 hover:text-red-400 hover:bg-red-500/5 w-full transition-all">
            <LogOut className="w-5 h-5" /> Logout
          </button>
        </div>
      </aside>

      <div className="flex-1 md:ml-64">
        <header className="h-20 glass border-b border-amber-500/15 flex items-center justify-between px-6 sticky top-0 z-40">
          <div><div className="text-sm text-slate-400">Administration</div><div className="font-display font-bold text-lg">MoneyMoonX Control</div></div>
          <div className="flex items-center gap-4">
            <div className="text-right hidden sm:block"><div className="text-xs text-slate-500 uppercase">Logged in</div><div className="text-amber-400 font-semibold text-sm">{user?.email}</div></div>
            <button data-testid="admin-header-logout-btn" onClick={() => { logout(); navigate("/"); }}
              className="flex items-center gap-2 px-3 py-2 rounded-xl text-sm text-slate-300 border border-red-500/30 hover:text-red-400 hover:bg-red-500/10 transition-all">
              <LogOut className="w-4 h-4" /> <span className="hidden sm:inline">Logout</span>
            </button>
          </div>
        </header>
        <div className="md:hidden flex overflow-x-auto gap-2 p-3 border-b border-amber-500/15 bg-[#08080C]">
          {nav.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end}
              className={({ isActive }) => `flex items-center gap-2 px-3 py-2 rounded-lg text-xs whitespace-nowrap ${isActive ? "gold-btn" : "text-slate-400 border border-amber-500/15"}`}>
              <n.icon className="w-4 h-4" /> {n.label}
            </NavLink>
          ))}
        </div>
        <main className="p-4 sm:p-6 lg:p-8"><Outlet /></main>
      </div>
    </div>
  );
}
